@if (mappedAttachments!.length > 0) {
  @for (attachment of mappedAttachments; track attachment) {
    <ion-col size-lg="6" size-md="6" size-sm="6" size-xs="12">
      @if (getAttachmentByType(attachment.type!); as attachmentInfo) {
        <ion-item [disabled]="(attachmentsService.checkLoadingButton(attachment.loadingId) | async)"
                  [lines]="lines"
                  class="status"
        >
          <ion-button (click)="attachmentsService.dispatchAction(attachment)" fill="outline" slot="start">
            @if (!(attachmentsService.checkLoadingButton(attachment.loadingId) | async)) {
              <ion-icon
                [name]="attachmentInfo.icon"/>
            }
            @if ((attachmentsService.checkLoadingButton(attachment.loadingId) | async)) {
              <ion-spinner
                slot="end"/>
            }
          </ion-button>
          <ion-input [label]="attachmentInfo.label" [readonly]="true"
                     [value]="attachment.name"
                     labelPlacement="stacked"/>
        </ion-item>
      }
    </ion-col>
  }
}
